export default "__VITE_PUBLIC_ASSET__fe8b43a8__"